import React from 'react';
import { MdEmail, MdPhoneInTalk } from 'react-icons/md';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
// import { BsArrowLeftRight } from 'react-icons/bs';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import {
  // BiTransfer
  BiTransfer
} from 'react-icons/bi';
import { IoLogoWhatsapp } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import buildingIcon from '../../../src/assets/images/building.png';
import { isMobileViewHook } from '../../CustomHooks/isMobileViewHook';
import { restrictOnlyUserActions } from '../../Helper/restrictActions';
import { imageUrl } from '../../config/apiUrl';
import { Area, mapPin } from '../../constant/imagePath';
import { useFavoriteEntityMutation, usePostApiMutation } from '../../store/apiSlice/apiSlice';
import { updateUser } from '../../store/auth/authSlice';
// import { usdToOther } from '../../utils/helpers';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { usdToOther2 } from '../../utils/helpers';
import Tooltip from '../Tooltip';
import classes from './ProjectHorizontalCard.module.css';

/* eslint-disable */

const ProjectHorizontalCard = ({
  data,
  index,
  className = '',
  onEmailClick = () => null,
  refetch
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('webCommon');
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { currency } = useSelector((state) => state.converterReducer);

  const { user, isLogin } = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = React.useState(false);
  const [postApiFunc] = usePostApiMutation();

  const [onFavorite, { isLoading: isFavoriting }] = useFavoriteEntityMutation();

  const responsiveSettings = [
    { breakpoint: isMobile ? 700 : 465, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    { breakpoint: 200, settings: { slidesToShow: 1, slidesToScroll: 1 } }
  ];

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);

  const allowCallOrWhatsApp = data?.assignedAgent ?? data?.agent ?? data?.company;

  const handleCompare = async (data) => {
    const onlyCompareProperty = user?.compareList?.filter((item) => item?.type == 'Project');
    const ifAlreadyExist = onlyCompareProperty?.find((item) => item?.entity == data?._id);
    if (!ifAlreadyExist && onlyCompareProperty?.length >= 3)
      return toast.error(t('projectCard.toast.error'));

    const response = await postApiFunc({
      url: `users/compare/add`,
      method: 'POST',
      tag: `compareListFront`,
      data: {
        id: data?._id,
        type: 'project'
      }
    });
    if (response?.data) {
      dispatch(updateUser(response?.data?.data));
      toast.success(
        `${t('projectCard.project')} ${
          ifAlreadyExist ? t('projectCard.toast.removedFrom') : t('projectCard.toast.addedIn')
        } ${t('projectCard.toast.success')}`
      );
    }
  };

  const isFavorite = data?.favoriteBy?.includes(user?._id);
  const handleFavorite = async () => {
    if (isFavoriting) return;
    const res = await onFavorite({ id: data?._id, type: 'project' });
    refetch && refetch();
    if (res?.data) {
      // if (res?.data?.data?.favoriteBy?.includes(user?._id))
      if (res?.data?.data) {
        toast.success(t('projectCard.toast.removeFromFavList'));
      } else {
        toast.success(t('projectCard.toast.addInFavList'));
      }
    }
  };

  const handleAction = () => {
    const isAllowedActions = restrictOnlyUserActions(user?.role);
    if (!isLogin) {
      navigate('/login');
    } else if (isAllowedActions) {
      return true;
    }
  };

  return (
    <>
      <style>
        {`
      .${classes.sliderContainer} .react-slideshow-container .default-nav{
        background: transparent;
        color:#FFFFFF !important;
        transition: 0.5s ease;
        opacity:0;
      }
      .${classes.sliderContainer} .react-slideshow-container .default-nav svg{
        fill:#FFFFFF !important;
      }
      .${classes.sliderContainer} .react-slideshow-container .default-nav:hover{
        background: transparent;
      }

      .${classes.sliderContainer}:hover .react-slideshow-container .default-nav{
        opacity:1;
      }

                    a {
          text-decoration: none;
          color: inherit;
        }
          a:hover {
            text-decoration: none;
            color: inherit;
          }
      `}
      </style>
      <div className={[classes?.propertyMain, className].join(' ')}>
        {/* Slider */}
        <div className={classes?.sliderContainer}>
          {/* <Slide slidesToScroll={2} slidesToShow={2} responsive={responsiveSettings}>
            {data?.images?.map((image, i) => (
              <div className={classes?.propertyImageContainer} key={i}>
                <img src={imageUrl(image)} draggable={false} />
              </div>
            ))}
          </Slide> */}
          <div className={classes.iconWrapCustom}>
            <Tooltip text={t('projectCard.tooltips.compare')}>
              <div className={classes.iconBorder}>
                <BiTransfer
                  size={32}
                  onClick={(e) => {
                    e.preventDefault();
                    e?.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    if (!handleAction()) return;
                    handleCompare(data);
                  }}
                  className={classes.iconsBottom}
                  fill={`${
                    user?.compareList?.find((item) => item?.entity == data?._id)
                      ? 'var(--action-icon-clr)'
                      : 'white'
                  } `}
                />
              </div>
            </Tooltip>
            <Tooltip
              text={
                isFavorite
                  ? t('projectCard.tooltips.removeFavorite')
                  : t('projectCard.tooltips.addFavorite')
              }>
              {isFavorite ? (
                <div className={classes.iconBorder}>
                  <AiFillHeart
                    onClick={(e) => {
                      e.preventDefault();
                      e?.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();
                      handleFavorite();
                    }}
                    fill="white"
                    className={classes.iconsBottom}
                  />
                </div>
              ) : (
                <div className={classes.iconBorder}>
                  <AiOutlineHeart
                    onClick={(e) => {
                      e.preventDefault();
                      e?.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();
                      if (!handleAction()) return;
                      handleFavorite();
                    }}
                    fill="white"
                    className={classes.iconsBottom}
                  />
                </div>
              )}
            </Tooltip>
          </div>
          <PhotoProvider>
            <Slide slidesToScroll={2} slidesToShow={2} responsive={responsiveSettings}>
              {data?.images?.map((image, i) => (
                <div className={classes?.propertyImageContainer} key={i}>
                  <PhotoView src={imageUrl(image)}>
                    <img src={imageUrl(image)} draggable={false} alt={`slide-${i}`} />
                  </PhotoView>
                  {/* <div className={classes.iconWrapCustom}>
                    <Tooltip text={t('projectCard.tooltips.compare')}>
                      <div className={classes.iconBorder}>
                        <BiTransfer
                          size={32}
                          onClick={(e) => {
                            e.preventDefault();
                            e?.stopPropagation();
                            e.nativeEvent.stopImmediatePropagation();
                            if (!handleAction()) return;
                            handleCompare(data);
                          }}
                          className={classes.iconsBottom}
                          fill={`${
                            user?.compareList?.find((item) => item?.entity == data?._id)
                              ? 'var(--action-icon-clr)'
                              : 'white'
                          } `}
                        />
                      </div>
                    </Tooltip>
                    <Tooltip
                      text={
                        isFavorite
                          ? t('projectCard.tooltips.removeFavorite')
                          : t('projectCard.tooltips.addFavorite')
                      }>
                      {isFavorite ? (
                        <div className={classes.iconBorder}>
                          <AiFillHeart
                            onClick={(e) => {
                              e.preventDefault();
                              e?.stopPropagation();
                              e.nativeEvent.stopImmediatePropagation();
                              handleFavorite();
                            }}
                            fill="white"
                            className={classes.iconsBottom}
                          />
                        </div>
                      ) : (
                        <div className={classes.iconBorder}>
                          <AiOutlineHeart
                            onClick={(e) => {
                              e.preventDefault();
                              e?.stopPropagation();
                              e.nativeEvent.stopImmediatePropagation();
                              if (!handleAction()) return;
                              handleFavorite();
                            }}
                            fill="white"
                            className={classes.iconsBottom}
                          />
                        </div>
                      )}
                    </Tooltip>
                  </div> */}
                  {data?.isFeatured && (
                    <div className={[classes?.featuredPremiumContainer].join(' ')}>
                      <span>
                        <RiVipCrownFill color="#FBC56C" size={14} />
                      </span>
                      <span className={classes?.premiumIco}>
                        <span>{t('projectCard.premium')}</span>
                      </span>
                    </div>
                  )}
                  {data?.isPremium && (
                    <div className={classes?.featuredPremium}>
                      <span>{<TiStarFullOutline color="#FFFFFF" size={14} />}</span>
                      <span className={classes?.featuredIco}>
                        <span>{t('projectCard.featured')}</span>
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </Slide>
          </PhotoProvider>
        </div>
        <Link to={`/projects/${data?.slug ?? '1'}`} className={classes?.rightContainer}>
          <div className={classes.paddingDiv}>
            {/* <div
            className={classes?.rightContainer}
            onClick={() => {
              navigate(`/projects/${data?.slug ?? '1'}`);
            }}> */}

            {/* Price + Logo */}
            <div className={classes?.topContainer}>
              <div className={classes?.priceContainer}>
                <h6>{data?.name?.[selectedLanguage]}</h6>
                <p>{data?.title?.[selectedLanguage]}</p>
                <div className={classes?.location}>
                  <img className={classes.locationImg} src={mapPin} alt="location" />
                  <span>{data?.address}</span>
                </div>
                {/* <span>
                {t('words.from')} {usdToOther2({ amount: data?.price, ...currency })}
              </span> */}
              </div>
              <div
                className={classes?.logoContainer}
                onClick={(e) => {
                  e.preventDefault();
                  e?.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  navigate(`/company/${data?.company?.slug}`);
                }}>
                <img src={imageUrl(data?.company?.photo)} />
              </div>
            </div>
            {/* Property Info */}

            <div className={classes?.propertyInfoContainer}>
              {/* <IconList
                className={classes.infoIcons}
                Icon={BiBuildingHouse}
                label={t('projectCard.tooltips.projectType')}
                value={data?.projectType?.title?.[selectedLanguage]}
              /> */}
              <Tooltip text={t('projectCard.tooltips.projectType')}>
                <div className={classes.iconContainer}>
                  <img src={buildingIcon} alt="buildingIcon" />
                  <p>{data?.projectType?.title?.[selectedLanguage]}</p>
                </div>
              </Tooltip>
              <div className={classes.propertyDetail}>
                <Tooltip text={t('projectCard.tooltips.noOfUnits')}>
                  <img src={Area} alt="building" />
                </Tooltip>
                <p className="p18">
                  {data?.noOfUnits} {t('projectCard.units')}
                </p>
              </div>
            </div>
          </div>

          {/* bottom strip */}
          <div className={classes?.bottomStrip}>
            <div className={classes.socialIconsWrap1}>
              <div
                className={classes.socialIcons1}
                onClick={(e) => {
                  // e.preventDefault();
                  e?.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                }}>
                <Tooltip
                  text={t('projectCard.tooltips.call')}
                  href={`tel:${allowCallOrWhatsApp?.phoneNumber}`}>
                  <MdPhoneInTalk fill="#00A997" className={classes.iconsBottom} />
                </Tooltip>
              </div>
              <div
                className={[classes.socialIcons1, classes.midIcon].join(' ')}
                onClick={(e) => {
                  e.preventDefault();
                  e?.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  onEmailClick && onEmailClick();
                }}>
                <Tooltip text={t('projectCard.tooltips.email')}>
                  <MdEmail fill="#00A997" className={classes.iconsBottom} />
                </Tooltip>
              </div>
              <div
                className={classes.socialIcons1}
                onClick={(e) => {
                  // e.preventDefault();
                  e?.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                }}>
                <Tooltip
                  text={t('projectCard.tooltips.whatsapp')}
                  href={`https://wa.me/${allowCallOrWhatsApp?.whatsapp}`}
                  target={'_blank'}>
                  <IoLogoWhatsapp fill="#00A997" className={classes.iconsBottom} />
                </Tooltip>
              </div>
            </div>
            {/* right */}
            <span className={classes.currency}>
              <span className={classes.startingFrom}>{t('projectCard.startingFrom')}</span>
              {usdToOther2({ amount: data?.price, ...currency })}
            </span>
          </div>
          {/* </div> */}

          {/* {(data?.isPremium || data?.isFeatured) && (
            <div className={classes?.featuredPremiumContainer}>
              <span
                className={`${
                  (data?.isFeatured && classes?.featuredIco) ||
                  (data?.isPremium && classes?.premiumIco)
                }`}>
                {(data?.isPremium && t('projectCard.premium')) ||
                  (data?.isFeatured && t('projectCard.featured'))}
              </span>
            </div>
          )} */}
        </Link>
      </div>
    </>
  );
};

export default ProjectHorizontalCard;

// const responsiveSettings = [
//   {
//     breakpoint: 800,
//     settings: {
//       slidesToShow: 3,
//       slidesToScroll: 3
//     }
//   },
//   {
//     breakpoint: 500,
//     settings: {
//       slidesToShow: 2,
//       slidesToScroll: 2
//     }
//   }
// ];

//  <div className={classes.iconWrap}>
//    <Tooltip text={t('projectCard.tooltips.compare')}>
//      <BiTransfer
//        onClick={(e) => {
//          e.preventDefault();
//          e?.stopPropagation();
//          e.nativeEvent.stopImmediatePropagation();
//          if (!handleAction()) return;
//          handleCompare(data);
//        }}
//        className={classes.iconsBottom}
//        fill={`${
//          user?.compareList?.find((item) => item?.entity == data?._id)
//            ? 'var(--action-icon-clr)'
//            : 'var(--text-light-gray-clr)'
//        } `}
//      />
//    </Tooltip>
//    <Tooltip
//      text={
//        isFavorite ? t('projectCard.tooltips.removeFavorite') : t('projectCard.tooltips.addFavorite')
//      }>
//      {isFavorite ? (
//        <AiFillHeart
//          onClick={(e) => {
//            e.preventDefault();
//            e?.stopPropagation();
//            e.nativeEvent.stopImmediatePropagation();
//            handleFavorite();
//          }}
//          fill="var(--action-icon-clr)"
//          className={classes.iconsBottom}
//        />
//      ) : (
//        <AiOutlineHeart
//          onClick={(e) => {
//            e.preventDefault();
//            e?.stopPropagation();
//            e.nativeEvent.stopImmediatePropagation();
//            if (!handleAction()) return;
//            handleFavorite();
//          }}
//          fill="var(--text-light-gray-clr)"
//          className={classes.iconsBottom}
//        />
//      )}
//    </Tooltip>
//  </div>;
